import type { DocumentVisibilityRequest, RoomDocument, RowMenuItem } from '@dataroom/shared';

/**
 * The document row's ⋯ menu entries for the admin's per-document override
 * (ADR-0028): hide from / show to the seller, and hide from / show to buyers.
 * Each toggles its own flag only; the other keeps its value server-side.
 */
export function visibilityMenuItems(
  doc: Pick<RoomDocument, 'hiddenFromSeller' | 'hiddenFromBuyers'>,
  set: (body: DocumentVisibilityRequest) => void,
  disabled: boolean,
): RowMenuItem[] {
  const seller = doc.hiddenFromSeller === true;
  const buyers = doc.hiddenFromBuyers === true;
  return [
    {
      label: seller ? 'Show to seller' : 'Hide from seller',
      icon: seller ? 'eye' : 'lock',
      disabled,
      onSelect: () => set({ hiddenFromSeller: !seller }),
    },
    {
      label: buyers ? 'Show to buyers' : 'Hide from buyers',
      icon: buyers ? 'eye' : 'lock',
      disabled,
      onSelect: () => set({ hiddenFromBuyers: !buyers }),
    },
  ];
}
